"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TODO_STATE;
(function (TODO_STATE) {
    TODO_STATE["TODO"] = "TODO";
    TODO_STATE["DONE"] = "DONE";
    TODO_STATE["IN_PROGRESS"] = "IN_PROGRESS";
})(TODO_STATE = exports.TODO_STATE || (exports.TODO_STATE = {}));
